<template>
    <div>
        <b-card>
          <h3>Confirm Details</h3>
          <br/>
          <b-row>
            <b-col>Confirm Details Here</b-col>
          </b-row>
        </b-card>
    </div>
</template>

<script>
    export default {
      data() {
      return {
        stepComplete: false,
      }
    },
    computed: {},
    components: {},
    methods:{},

    }
</script>

<style>

</style>